import { onToast } from "@components/Toast";

const displayAttentionNotification = (description: string) => {
	onToast({
		id: "notification-if-offline",
		message: "Attention",
		description: description,
	});
};

export const showNotificationIfOffline = (
	curStatus2D: boolean,
	curStatus3D: boolean,
	is2DStreamActive: boolean = false,
	is3DStreamActive: boolean = false,
) => {
	let initStatus2D = is2DStreamActive;
	let initStatus3D = is3DStreamActive;

	if (!initStatus2D && !initStatus3D) {
		initStatus2D = curStatus2D;
		initStatus3D = curStatus3D;
		return;
	}

	// a) Only 2D was active, but current 2D status is inactive:
	const caseA = initStatus2D && !initStatus3D && !curStatus2D;
	if (caseA) {
		displayAttentionNotification("Your 2D stream has been stopped");
	}

	// b) Only 3D was active, but current 3D status is inactive:
	const caseB = !initStatus2D && initStatus3D && !curStatus3D;
	if (caseB) {
		displayAttentionNotification("Your VR stream has been stopped");
	}

	// c) Both were active, but current 2D is inactive AND current 3D is inactive
	const caseC = initStatus2D && initStatus3D && !curStatus3D && !curStatus2D;
	if (caseC) {
		displayAttentionNotification("Your streams has been stopped");
	}

	// d) Both were active, but current 3D is inactive
	const caseD = initStatus2D && initStatus3D && !curStatus3D;
	if (caseD) {
		displayAttentionNotification("Your VR stream has been stopped");
	}

	// e) Both were active, but current 2D is inactive
	const caseE = initStatus2D && initStatus3D && !curStatus2D;
	if (caseE) {
		displayAttentionNotification("Your 2D stream has been stopped");
	}
};
